export default function InstagramSection() {
  return (
    <section id="instagram" className="py-24 px-6 lg:px-12 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto text-center">
        <div className="mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 mb-6">
            <i className="ri-instagram-line text-4xl text-white"></i>
          </div>
          
          <h2 className="text-xl font-bold text-gray-900 mb-4 whitespace-nowrap" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
            Instagramで日々の活動を発信中
          </h2>
          
          <p className="text-xs text-gray-600 max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
            トレーニングの様子やベンチプレスの記録更新など、<br />
            日々の活動をリアルタイムでシェアしています。<br />
            ぜひフォローしてください！
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          <div className="aspect-square rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <img 
              src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/0cd0a2c8880b5b61cfd32e2dcf8dd138.jpeg"
              alt="Instagram Post"
              className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="aspect-square rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <img 
              src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/8f9ac50564dafaa88769d19f558fc0f8.jpeg"
              alt="Instagram Post"
              className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="aspect-square rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <img 
              src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/68d5b868fa79f46e7d624f2916044ec2.jpeg"
              alt="Instagram Post"
              className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="aspect-square rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <img 
              src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/e2e4151271fbc9a4781266f994c47cd0.jpeg"
              alt="Instagram Post"
              className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
            />
          </div>
        </div>
        
        <a 
          href="https://www.instagram.com/jasuta_press?igsh=emF6aTlraG12ZW9u&utm_source=qr" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 text-white hover:shadow-2xl transition-all cursor-pointer"
        >
          <i className="ri-instagram-line text-3xl"></i>
        </a>
      </div>
    </section>
  );
}